import React from 'react';
import Footer from "../components/Footer";
import Header from "../components/Header";
import Home from "../components/Home";

const HomePage = () => {
  return (
    <>
      <Header />
      <Home />
      <Footer />
    </>
  );
};

export default HomePage;
